// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"a165eff3","164":"9db8f39b","218":"15a4fc89","281":"f0993e47","723":"ab50ed4f","746":"658155c7","929":"37c60520","992":"b6903bf1"}[chunkId] + ".chunk.js";
};